import { Redirect } from "expo-router";
import { useTenantId } from "@src/features/tenants";

export default function ActivityScreen() {
  const tenantId = useTenantId();

  if (tenantId) {
    return <Redirect href={`/tenants/${tenantId}/activity` as never} />;
  }

  return null;
}
